import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loader from 'components/shared/Loader';
import * as types from 'misc/types';
import { isCorrectContentType, trackGA } from 'misc/helpers';
import { API_URL } from 'misc/endpoint.js';

class DocumentViewer extends Component {

    render = () => {
        
        const { sessions, envelope_contents } = this.props;
        
        let inline_content = '';

        const contentId = this.props.match.params.id;

        // Get content info from store
        const contentInfo = envelope_contents.data.filter(function(c) {
            return c.id === contentId;
        });
    
        let contentURL = '';

        let contentBody = undefined;

        if (contentInfo !== undefined && contentInfo.length > 0) {
            contentBody = contentInfo[0];

            contentURL =    API_URL.SERVICE +
                            'envelopes/' +
                            contentBody.envelopeId +
                            '/body/' +
                            contentBody.id +
                            '/data';
        }
      
        if (contentBody) {
            console.log("content type: "+contentBody.contentType);
            if (isCorrectContentType(contentBody.contentType, [types.CONTENT_TYPES.HTML,types.CONTENT_TYPES.PDF,types.CONTENT_TYPES.TEXT])) {
               
                inline_content = (
                    <React.Fragment>
                        <iframe
                                title="Content"
                                className="fill-parent"
                                src={contentURL}
                                type={contentBody.contentType}
                                frameBorder="0"
                                scrolling="no"
                                width="100%"
                                height="100%"
                                id="printf"
                                name="printf"
                            />
                    </React.Fragment>
                );
            } else {
                // Download document if no any of the above types
                var a = window.document.createElement('a');

                // Present document for download
                a.href = contentURL;
                a.download = contentBody.filename;

                // Append anchor to body.
                document.body.appendChild(a);
                a.click();

                // Remove anchor from body
                document.body.removeChild(a);
            }
        }

        return (
            <Loader objectToLoad={envelope_contents}>
                <div className="content fill-parent">
                    {inline_content}
                </div>
            </Loader>
        );
    };

    componentDidMount() {
        trackGA('5.1 Bilaga');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions,
        document: state.envelope_content_extern,
        envelope_contents: state.envelope_contents,
    };
};

export default connect(mapStateToProps)(DocumentViewer);



// WEBPACK FOOTER //
// ./src/components/views/inbox/DocumentViewer.js